export const LsoEntities = {
    ALL_DASHBOARD_DATA: "allDashboardData",
    ALL_ACCOUNTING_ENTITIES: "allAccountingEntitites",
    SALES_REGION: "salesRegion",
    SUB_REGION: "subRegion",
    LSO: "lso",
    COUNTRY: "country",
  };

export function mapResultsToSelectionOptions(results = [], type) {
  const mappedResults = results
    .sort((a, b) => (a.name < b.name ? -1 : 1)) // sorting could be removed when result could come already sorted from the
    .map((item) => {
      return {
        value: type ? item.id + "_" + type : item.id, // value: item.id,
        label: item.name,
        type: type, // use this to distinghuish them from other entities
        ...item.styling,
      };
    });
  return mappedResults.length ? mappedResults : null;
}

export function extractIdNumberFromSelectedOption(option, condition = true) {
    if(condition) {
        return parseInt(option.value.split("_")[0])
    } 
    return null;
}

export const yearRange = [
  {
    value: new Date().getFullYear() - 3,
    label: (new Date().getFullYear() - 3).toString(),
  },
  {
    value: new Date().getFullYear() - 2,
    label: (new Date().getFullYear() - 2).toString(),
  },
  {
    value: new Date().getFullYear() - 1,
    label: (new Date().getFullYear() - 1).toString(),
  },
  {
    value: new Date().getFullYear(),
    label: new Date().getFullYear().toString(),
  },
  {
    value: new Date().getFullYear() + 1,
    label: (new Date().getFullYear() + 1).toString(),
  },
  {
    value: new Date().getFullYear() + 2,
    label: (new Date().getFullYear() + 2).toString(),
  },
  {
    value: new Date().getFullYear() + 3,
    label: (new Date().getFullYear() + 3).toString(),
  },
];
